import React, { useState, useEffect } from "react";
import { db } from "../../../firebase/config";
import { collection, query, where, getDocs, addDoc, updateDoc, doc, Timestamp, orderBy } from "firebase/firestore";
import { useAuth } from "../../../context/AuthContext";
import { useTheme } from "../../../context/ThemeContext";
import Header from "../../../components/Header";
import { registrarAccion } from "../../../utils/trazabilidad";


export default function Honorarios() {
  const { currentUser, userRole, clinicaId, clinicaData } = useAuth();
  const MEDICOS = [
  { id: 'medico1', nombre: clinicaData?.medicos?.medico1 || 'Médico 1' },
  { id: 'medico2', nombre: clinicaData?.medicos?.medico2 || 'Médico 2' },
  { id: 'medico3', nombre: clinicaData?.medicos?.medico3 || 'Médico 3' },
  { id: 'medico4', nombre: clinicaData?.medicos?.medico4 || 'Médico 4' },
];
  const { theme } = useTheme();

  const canEdit = ['gestion_general', 'administracion'].includes(userRole);
  const esMedico = userRole === 'medico';

  const [medicoSel, setMedicoSel] = useState('medico1');
  const [fechaDesde, setFechaDesde] = useState(() => { const d = new Date(); d.setDate(1); return d.toISOString().split('T')[0]; });
  const [fechaHasta, setFechaHasta] = useState(() => new Date().toISOString().split('T')[0]);
  const [cargando, setCargando] = useState(false);
  const [turnos, setTurnos] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [expandidoLiq, setExpandidoLiq] = useState(null);
  const [calculado, setCalculado] = useState(false);

  const [liquidacionPorIngreso, setLiquidacionPorIngreso] = useState({});
  const [extrasSum, setExtrasSum] = useState([{ concepto: '', monto: '' }]);
  const [extrasDed, setExtrasDed] = useState([{ concepto: '', monto: '' }]);

  const btnPrimaryStyle = { background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`, border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: '#FFFFFF', fontWeight: '600', fontFamily: "'Montserrat', sans-serif" };
  const btnSecondaryStyle = { background: 'transparent', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: theme.secondary, fontFamily: "'Montserrat', sans-serif" };
  const inputStyle = { width: '100%', padding: '10px 14px', fontSize: '13px', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', outline: 'none', color: theme.primary, background: theme.bgInput, boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif" };
  const inputSmall = { padding: '6px 10px', fontSize: '12px', border: `0.5px solid ${theme.borderInput}`, borderRadius: '6px', outline: 'none', color: theme.primary, background: theme.bgInput, fontFamily: "'Montserrat', sans-serif" };
  const labelStyle = { fontSize: '11px', color: theme.secondary, display: 'block', marginBottom: '6px', fontWeight: '500', letterSpacing: '1px' };

  useEffect(() => {
    if (!clinicaId) return;
    const q = query(collection(db, 'liquidaciones_honorarios'), where('clinicaId', '==', clinicaId), where('medico', '==', medicoSel), orderBy('creadoEn', 'desc'));
    getDocs(q).then(snap => setLiquidaciones(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [clinicaId, medicoSel]);

  async function calcular() {
    if (!fechaDesde || !fechaHasta) return;
    setCargando(true);
    setCalculado(false);
    const inicio = new Date(fechaDesde + 'T00:00:00');
    const fin = new Date(fechaHasta + 'T23:59:59');

    const qTurnos = query(collection(db, 'turnos'), where('clinicaId', '==', clinicaId), where('medico', '==', medicoSel), where('estado', '==', 'atendido'), where('fecha', '>=', Timestamp.fromDate(inicio)), where('fecha', '<=', Timestamp.fromDate(fin)));
    const snapTurnos = await getDocs(qTurnos);
    const turnosData = snapTurnos.docs.map(d => ({ id: d.id, ...d.data() }));
    setTurnos(turnosData);

    const qIngresos = query(collection(db, 'caja'), where('clinicaId', '==', clinicaId), where('medico', '==', medicoSel), where('tipo', '==', 'ingreso'), where('fecha', '>=', Timestamp.fromDate(inicio)), where('fecha', '<=', Timestamp.fromDate(fin)));
    const snapIngresos = await getDocs(qIngresos);
    const ingresosData = snapIngresos.docs.map(d => ({ id: d.id, ...d.data() }));
    setIngresos(ingresosData);

    const liqInicial = {};
    ingresosData.forEach(ing => { liqInicial[ing.id] = { modo: 'porcentaje', valor: '' }; });
    setLiquidacionPorIngreso(liqInicial);
    setExtrasSum([{ concepto: '', monto: '' }]);
    setExtrasDed([{ concepto: '', monto: '' }]);
    setCalculado(true);
    setCargando(false);
  }

  function calcularHonorarioIngreso(ing) {
    const liq = liquidacionPorIngreso[ing.id];
    if (!liq || !liq.valor) return 0;
    const monto = parseFloat(ing.monto) || 0;
    const valor = parseFloat(liq.valor) || 0;
    if (liq.modo === 'porcentaje') return (monto * valor) / 100;
    return valor;
  }

  const totalHonorariosIngresos = ingresos.reduce((a, ing) => a + calcularHonorarioIngreso(ing), 0);
  const totalExtrasSum = extrasSum.reduce((a, e) => a + (parseFloat(e.monto) || 0), 0);
  const totalExtrasDed = extrasDed.reduce((a, e) => a + (parseFloat(e.monto) || 0), 0);
  const totalLiquidacion = totalHonorariosIngresos + totalExtrasSum - totalExtrasDed;

  const tipoLabel = { consulta: 'Consulta', control: 'Control', estudio: 'Estudio', cirugia: 'Cirugía' };
  const tipoBadge = { consulta: { bg: theme.infoBg, color: theme.accent }, control: { bg: theme.successBg, color: theme.success }, estudio: { bg: theme.warningBg, color: theme.warning }, cirugia: { bg: theme.errorBg, color: theme.error } };

  async function confirmarLiquidacion() {
    if (!window.confirm('¿Confirmar esta liquidación?')) return;
    const detalle = ingresos.map(ing => ({
      ingresoId: ing.id, categoria: ing.categoria, detalle: ing.detalle,
      montoIngreso: ing.monto, moneda: ing.moneda,
      modo: liquidacionPorIngreso[ing.id]?.modo,
      valor: liquidacionPorIngreso[ing.id]?.valor,
      honorario: calcularHonorarioIngreso(ing),
    }));
    await addDoc(collection(db, 'liquidaciones_honorarios'), {
      clinicaId, medico: medicoSel, medicoNombre: MEDICOS.find(m => m.id === medicoSel)?.nombre,
      fechaDesde, fechaHasta,
      turnosAtendidos: turnos.length,
      detalleTurnos: turnos.map(t => ({ id: t.id, tipo: t.tipo, paciente: t.paciente, fecha: t.fecha })),
      detalleIngresos: detalle,
      extrasSum, extrasDed,
      totalHonorariosIngresos, totalExtrasSum, totalExtrasDed, totalLiquidacion,
      estado: 'liquidado', creadoEn: new Date(), creadoPor: currentUser?.email,
    });
    await registrarAccion(currentUser?.email, userRole, 'Honorarios', 'Confirmar liquidación', `${MEDICOS.find(m => m.id === medicoSel)?.nombre} · $${totalLiquidacion.toLocaleString('es-AR')}`, clinicaId);
    setCalculado(false);
    setTurnos([]); setIngresos([]);
    const q = query(collection(db, 'liquidaciones_honorarios'), where('clinicaId', '==', clinicaId), where('medico', '==', medicoSel), orderBy('creadoEn', 'desc'));
    getDocs(q).then(snap => setLiquidaciones(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }

  async function marcarPagado(liqId) {
    await updateDoc(doc(db, 'liquidaciones_honorarios', liqId), { estado: 'pagado', fechaPago: new Date(), pagadoPor: currentUser?.email });
    await registrarAccion(currentUser?.email, userRole, 'Honorarios', 'Marcar pagado', liqId, clinicaId);
    setLiquidaciones(prev => prev.map(l => l.id === liqId ? { ...l, estado: 'pagado' } : l));
  }

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Honorarios Médicos" backLabel="Dashboard" backRuta="/dashboard" />
      <div style={{ padding: '24px', background: theme.bg, display: 'flex', flexDirection: 'column', gap: '20px' }}>

        <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
          <div style={{ fontSize: '11px', fontWeight: '700', color: theme.accent, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>Selección de período</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px', alignItems: 'flex-end' }}>
            <div>
              <label style={labelStyle}>MÉDICO</label>
              <select value={medicoSel} onChange={e => { setMedicoSel(e.target.value); setCalculado(false); setTurnos([]); setIngresos([]); }} style={inputStyle}>
                {MEDICOS.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>DESDE</label>
              <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>HASTA</label>
              <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} style={inputStyle} />
            </div>
            {canEdit && (
              <button onClick={calcular} disabled={cargando} style={{ ...btnPrimaryStyle, height: '42px' }}>
                {cargando ? 'Calculando...' : 'Calcular'}
              </button>
            )}
          </div>
        </div>

        {calculado && (
          <>
            <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: theme.accent, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>
                Turnos atendidos — {turnos.length}
              </div>
              {turnos.length === 0
                ? <div style={{ fontSize: '13px', color: theme.secondary, textAlign: 'center', padding: '16px' }}>No hay turnos atendidos en este período</div>
                : <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {turnos.map(t => {
                      const fecha = t.fecha?.toDate ? t.fecha.toDate().toLocaleDateString('es-AR') : '—';
                      const tB = tipoBadge[t.tipo] || { bg: theme.bgCard, color: theme.secondary };
                      return (
                        <div key={t.id} style={{ background: theme.bg, borderRadius: '8px', padding: '8px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                          <div>
                            <div style={{ fontSize: '13px', fontWeight: '500', color: theme.primary }}>{t.paciente}</div>
                            <div style={{ fontSize: '11px', color: theme.secondary }}>{fecha} · {t.cobertura}</div>
                          </div>
                          <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '99px', background: tB.bg, color: tB.color, fontWeight: '500' }}>{tipoLabel[t.tipo] || t.tipo}</span>
                        </div>
                      );
                    })}
                  </div>
              }
            </div>

            <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: theme.accent, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>
                Ingresos asociados — liquidación por concepto
              </div>
              {ingresos.length === 0
                ? <div style={{ fontSize: '13px', color: theme.secondary, textAlign: 'center', padding: '16px' }}>No hay ingresos asociados a este médico en el período</div>
                : <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', gap: '8px', alignItems: 'center', padding: '0 4px', marginBottom: '4px' }}>
                      <span style={{ fontSize: '10px', color: theme.secondary, fontWeight: '600', letterSpacing: '1px' }}>CONCEPTO</span>
                      <span style={{ fontSize: '10px', color: theme.secondary, fontWeight: '600', letterSpacing: '1px' }}>MONTO</span>
                      <span style={{ fontSize: '10px', color: theme.secondary, fontWeight: '600', letterSpacing: '1px', minWidth: '160px' }}>LIQUIDACIÓN</span>
                      <span style={{ fontSize: '10px', color: theme.secondary, fontWeight: '600', letterSpacing: '1px', minWidth: '80px', textAlign: 'right' }}>HONORARIO</span>
                    </div>
                    {ingresos.map(ing => {
                      const liq = liquidacionPorIngreso[ing.id] || { modo: 'porcentaje', valor: '' };
                      const honorario = calcularHonorarioIngreso(ing);
                      return (
                        <div key={ing.id} style={{ background: theme.bg, borderRadius: '8px', padding: '10px 14px', display: 'grid', gridTemplateColumns: '1fr auto auto auto', gap: '8px', alignItems: 'center' }}>
                          <div>
                            <div style={{ fontSize: '13px', fontWeight: '500', color: theme.primary }}>{ing.categoria}{ing.detalle ? ` · ${ing.detalle}` : ''}</div>
                            <div style={{ fontSize: '11px', color: theme.secondary }}>{ing.paciente || '—'} · {ing.formaPago}</div>
                          </div>
                          <div style={{ fontSize: '14px', fontWeight: '600', color: theme.success, whiteSpace: 'nowrap' }}>
                            {ing.moneda === 'USD' ? 'USD ' : '$'}{parseFloat(ing.monto).toLocaleString('es-AR')}
                          </div>
                          {canEdit && (
                            <div style={{ display: 'flex', gap: '6px', alignItems: 'center', minWidth: '200px' }}>
                              <select value={liq.modo} onChange={e => setLiquidacionPorIngreso(prev => ({ ...prev, [ing.id]: { ...liq, modo: e.target.value, valor: '' } }))} style={{ ...inputSmall, width: '110px' }}>
                                <option value="porcentaje">% Porcentaje</option>
                                <option value="monto">$ Monto fijo</option>
                              </select>
                              <input type="number" value={liq.valor} onChange={e => setLiquidacionPorIngreso(prev => ({ ...prev, [ing.id]: { ...liq, valor: e.target.value } }))} placeholder={liq.modo === 'porcentaje' ? '50' : '15000'} style={{ ...inputSmall, width: '80px' }} />
                              {liq.modo === 'porcentaje' && <span style={{ fontSize: '12px', color: theme.secondary }}>%</span>}
                            </div>
                          )}
                          <div style={{ fontSize: '14px', fontWeight: '700', color: theme.accent, textAlign: 'right', whiteSpace: 'nowrap', minWidth: '80px' }}>
                            {ing.moneda === 'USD' ? 'USD ' : '$'}{honorario.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
              }
            </div>

            {canEdit && (
              <>
                <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: theme.success, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>Otros conceptos que suman</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {extrasSum.map((e, i) => (
                      <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: '8px', alignItems: 'center' }}>
                        <input value={e.concepto} onChange={v => { const n = [...extrasSum]; n[i].concepto = v.target.value; setExtrasSum(n); }} placeholder="Concepto..." style={inputSmall} />
                        <input type="number" value={e.monto} onChange={v => { const n = [...extrasSum]; n[i].monto = v.target.value; setExtrasSum(n); }} placeholder="Monto" style={{ ...inputSmall, width: '120px' }} />
                        <button onClick={() => setExtrasSum(prev => prev.filter((_, j) => j !== i))} style={{ ...btnSecondaryStyle, padding: '4px 8px', fontSize: '16px', color: theme.error }}>×</button>
                      </div>
                    ))}
                    <button onClick={() => setExtrasSum(prev => [...prev, { concepto: '', monto: '' }])} style={{ ...btnSecondaryStyle, alignSelf: 'flex-start', fontSize: '12px' }}>+ Agregar</button>
                  </div>
                </div>

                <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: theme.error, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>Deducciones</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {extrasDed.map((e, i) => (
                      <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: '8px', alignItems: 'center' }}>
                        <input value={e.concepto} onChange={v => { const n = [...extrasDed]; n[i].concepto = v.target.value; setExtrasDed(n); }} placeholder="Concepto..." style={inputSmall} />
                        <input type="number" value={e.monto} onChange={v => { const n = [...extrasDed]; n[i].monto = v.target.value; setExtrasDed(n); }} placeholder="Monto" style={{ ...inputSmall, width: '120px' }} />
                        <button onClick={() => setExtrasDed(prev => prev.filter((_, j) => j !== i))} style={{ ...btnSecondaryStyle, padding: '4px 8px', fontSize: '16px', color: theme.error }}>×</button>
                      </div>
                    ))}
                    <button onClick={() => setExtrasDed(prev => [...prev, { concepto: '', monto: '' }])} style={{ ...btnSecondaryStyle, alignSelf: 'flex-start', fontSize: '12px' }}>+ Agregar</button>
                  </div>
                </div>
              </>
            )}

            <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.accent}`, padding: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: theme.accent, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>Resumen de liquidación</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                {[
                  { label: 'Honorarios por ingresos', valor: totalHonorariosIngresos, color: theme.accent },
                  { label: 'Otros conceptos que suman', valor: totalExtrasSum, color: theme.success },
                  { label: 'Deducciones', valor: -totalExtrasDed, color: theme.error },
                ].map(item => (
                  <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: `0.5px solid ${theme.border}` }}>
                    <span style={{ fontSize: '13px', color: theme.secondary }}>{item.label}</span>
                    <span style={{ fontSize: '15px', fontWeight: '600', color: item.color }}>${item.valor.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
                  <span style={{ fontSize: '15px', fontWeight: '700', color: theme.primary }}>TOTAL LIQUIDACIÓN</span>
                  <span style={{ fontSize: '22px', fontWeight: '700', color: theme.accent }}>${totalLiquidacion.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
                </div>
              </div>
              {canEdit && (
                <button onClick={confirmarLiquidacion} style={{ ...btnPrimaryStyle, width: '100%', padding: '12px' }}>
                  Confirmar liquidación
                </button>
              )}
            </div>
          </>
        )}

        {liquidaciones.length > 0 && (
          <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: theme.secondary, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>Historial de liquidaciones</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {liquidaciones.map(liq => {
  const fecha = liq.creadoEn?.toDate ? liq.creadoEn.toDate().toLocaleDateString('es-AR') : '—';
  const expandido = expandidoLiq === liq.id;
  return (
    <div key={liq.id} style={{ background: theme.bg, borderRadius: '8px', border: `0.5px solid ${theme.border}`, overflow: 'hidden' }}>
      <div onClick={() => setExpandidoLiq(expandido ? null : liq.id)} style={{ padding: '12px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: '13px', fontWeight: '600', color: theme.primary }}>{liq.medicoNombre} · {liq.fechaDesde} al {liq.fechaHasta}</div>
          <div style={{ fontSize: '11px', color: theme.secondary }}>{liq.turnosAtendidos} turnos · Liquidado el {fecha}</div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '16px', fontWeight: '700', color: theme.accent }}>${(liq.totalLiquidacion || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
          <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '99px', fontWeight: '500', background: liq.estado === 'pagado' ? theme.successBg : theme.warningBg, color: liq.estado === 'pagado' ? theme.success : theme.warning }}>
            {liq.estado === 'pagado' ? 'Pagado' : 'Liquidado'}
          </span>
          {canEdit && liq.estado === 'liquidado' && (
            <button onClick={async e => {
              e.stopPropagation();
              await addDoc(collection(db, 'caja'), {
                tipo: 'egreso', categoria: 'Honorarios médicos',
                detalle: `${liq.medicoNombre} · ${liq.fechaDesde} al ${liq.fechaHasta}`,
                monto: liq.totalLiquidacion, moneda: 'ARS', formaPago: 'Transferencia',
                fecha: Timestamp.fromDate(new Date()),
                registradoPor: currentUser?.email, rol: userRole,
                estado: 'confirmado', clinicaId,
              });
              marcarPagado(liq.id);
            }} style={{ ...btnPrimaryStyle, fontSize: '11px', padding: '4px 10px' }}>Marcar pagado</button>
          )}
          <span style={{ color: theme.secondary, fontSize: '16px' }}>{expandido ? '▲' : '▼'}</span>
        </div>
      </div>
      {expandido && (
        <div style={{ padding: '0 16px 14px', borderTop: `0.5px solid ${theme.border}` }}>
          <div style={{ fontSize: '11px', fontWeight: '700', color: theme.secondary, letterSpacing: '1px', textTransform: 'uppercase', margin: '12px 0 8px' }}>Detalle de honorarios</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            {(liq.detalleIngresos || []).map((ing, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', padding: '6px 10px', background: theme.bgCard, borderRadius: '6px' }}>
                <div>
                  <span style={{ color: theme.primary }}>{ing.categoria}{ing.detalle ? ` · ${ing.detalle}` : ''}</span>
                  <span style={{ color: theme.secondary, marginLeft: '8px', fontSize: '11px' }}>
                    {ing.modo === 'porcentaje' ? `${ing.valor}%` : `$${parseFloat(ing.valor || 0).toLocaleString('es-AR')}`} sobre ${parseFloat(ing.montoIngreso || 0).toLocaleString('es-AR')}
                  </span>
                </div>
                <span style={{ color: theme.accent, fontWeight: '600' }}>${(ing.honorario || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
              </div>
            ))}
          </div>
          {(liq.extrasSum || []).filter(e => e.concepto || e.monto).length > 0 && (
            <div style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', color: theme.success, fontWeight: '600', marginBottom: '4px' }}>+ Conceptos adicionales</div>
              {liq.extrasSum.filter(e => e.concepto || e.monto).map((e, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', padding: '4px 10px' }}>
                  <span style={{ color: theme.secondary }}>{e.concepto}</span>
                  <span style={{ color: theme.success }}>${parseFloat(e.monto || 0).toLocaleString('es-AR')}</span>
                </div>
              ))}
            </div>
          )}
          {(liq.extrasDed || []).filter(e => e.concepto || e.monto).length > 0 && (
            <div style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', color: theme.error, fontWeight: '600', marginBottom: '4px' }}>− Deducciones</div>
              {liq.extrasDed.filter(e => e.concepto || e.monto).map((e, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', padding: '4px 10px' }}>
                  <span style={{ color: theme.secondary }}>{e.concepto}</span>
                  <span style={{ color: theme.error }}>${parseFloat(e.monto || 0).toLocaleString('es-AR')}</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: `0.5px solid ${theme.border}`, paddingTop: '8px', marginTop: '4px' }}>
            <span style={{ fontSize: '14px', fontWeight: '700', color: theme.accent }}>Total: ${(liq.totalLiquidacion || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
          </div>
        </div>
      )}
    </div>
  );
})}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}